var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import * as apcoaAPI from '@debbie/cortex/dist/api/bespoke/apcoa';
import { feeKey, parkingLotKey, useFee, } from '@debbie/cortex/dist/bespoke/apcoa';
import { h } from '@debbie/cortex/dist';
import q from '@debbie/cortex/dist/query';
import PlaceholderLoader from '../../PlaceholderLoader';
import Table from '../../Table';
import CopyToClipboard from '../../CopyToClipboard';
import THEME from '../../../theme';
import Alert from '../../Alert';
import { Edit } from '../../Icons';
import Modal from '../../Modal';
import Input from '../../Input';
import Button from '../../Button';
const Cancellations = (props) => {
    const { caseVoucher } = props;
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const [policy, setPolicy] = useState('');
    const [loading, setLoading] = useState(false);
    const [policyModalOpen, setPolicyModalOpen] = useState(false);
    console.log(fee);
    useEffect(() => {
        if (fee === null || fee === void 0 ? void 0 : fee.entitledForCancellation) {
            setPolicy(fee.entitledForCancellation);
        }
    }, [fee === null || fee === void 0 ? void 0 : fee.entitledForCancellation]);
    const savePolicy = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            if (!(fee === null || fee === void 0 ? void 0 : fee.parkingLotCode)) {
                throw new Error('No parking lot code');
            }
            yield apcoaAPI.patchParkingLot(fee.parkingLotCode, {
                policy,
            });
            q.invalidate([
                parkingLotKey(fee.parkingLotCode),
                feeKey(caseVoucher.referenceId),
            ]);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setPolicyModalOpen(false);
        setLoading(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(feeLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            h.hasData(feeLoadable) && fee ? (React.createElement(React.Fragment, null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", null, "Pladsejer"),
                        React.createElement("td", null, fee.parkingLotOwnerName)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Pladsnummer"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, { text: fee.parkingLotCode }, fee.parkingLotCode))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Adresse"),
                        React.createElement("td", null,
                            fee.parkingLotAddress,
                            React.createElement("br", null),
                            fee.parkingLotAddress2 ? (React.createElement(React.Fragment, null,
                                fee.parkingLotAddress2,
                                React.createElement("br", null))) : null)),
                    React.createElement("tr", { onClick: () => setPolicyModalOpen(!policyModalOpen), style: { cursor: 'pointer' } },
                        React.createElement("td", null, "Annulleringsberettiget"),
                        React.createElement("td", null,
                            fee.entitledForCancellation,
                            ' ',
                            React.createElement(Edit, { style: { float: 'right', cursor: 'pointer' } }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Annulleringer"),
                        React.createElement("td", null,
                            fee.noOfCancellations,
                            " / ",
                            fee.maxNoOfCancellations || '-')),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Antal Ejer14 annuleringer"),
                        React.createElement("td", null, fee.noOfOwner14Cancellations))))) : (!h.isError(feeLoadable) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" })))),
            policyModalOpen && (React.createElement(Modal, { header: 'Policy', onToggle: () => setPolicyModalOpen(!policyModalOpen), maxWidth: "500px" },
                React.createElement(Input, { placeholder: "Policy", onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            savePolicy();
                        }
                    }, value: policy, onChange: (e) => setPolicy(e.target.value), autofocus: true }),
                React.createElement("br", null),
                React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield savePolicy();
                    }) }, "Gem"))))));
};
export default Cancellations;
//# sourceMappingURL=Cancellations.js.map